import type { ReactNode } from "react";

export default function SectionHeader({
  eyebrow,
  title,
  support,
  action,
  dense = false,
  tight = false,
}: {
  eyebrow: string;
  title?: string;
  support?: string;

  action?: ReactNode;

  dense?: boolean;

  tight?: boolean;
}) {
  return (
    <div className={`flex flex-col ${tight ? "gap-3" : dense ? "gap-5" : "gap-8"}`}>
      <div className="flex flex-col gap-3">
        <div className="border-2 border-line"></div>

        <div className="flex items-start justify-between gap-6">
          <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-brand dark:text-[#DADADA]">
            {eyebrow}
          </p>

          {action && (
            <div className="pointer-events-auto shrink-0">{action}</div>
          )}
        </div>
      </div>

      {(title || support) && (
        <div className={`flex flex-col ${tight ? "gap-2" : dense ? "gap-3" : "gap-4"}`}>
          {title && (
            <h2
              className={`font-medium leading-tight text-ink max-w-3xl text-balance ${
                tight
                  ? "text-xl md:text-2xl"
                  : dense
                    ? "text-2xl md:text-4xl xl:text-[2.5rem]"
                    : "text-3xl md:text-5xl"
              }`}
            >
              {title}
            </h2>
          )}

          {support && (
            <p
              className={`font-light text-ink-muted max-w-2xl ${
                dense
                  ? "text-sm md:text-base xl:text-[1.0625rem]"
                  : "text-base md:text-lg"
              }`}
            >
              {support}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
